import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    emptyListCopy: string;
    emptyListCta: string;
    emptyListTitle: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Error state description */
            emptyListCopy: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ErrorFallback.emptyListCopy?c=281cz08p9cp15", defaultMessage: "Reload the page or check your internet connection." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to reload the page */
            emptyListCta: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ErrorFallback.emptyListCta?c=3apt6oncaajjc", defaultMessage: "Reload" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error state title */
            emptyListTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ErrorFallback.emptyListTitle?c=3hysb3djkf1u6", defaultMessage: "Something went wrong" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
